import {IMedicationCheckin} from 'redux/intervention/interfaces';

export type TimeOfDay = 'morning' | 'afternoon' | 'evening';

export interface IDoseCounts {
  total: number
  taken: number
  skipped: number
  missed: number
  pending: number
}

export interface IDoseSection {
  timeOfDay: TimeOfDay
  doses: IMedicationCheckin[]
}

const TIME_OF_DAY_ORDER: TimeOfDay[] = ['morning', 'afternoon', 'evening'];

export function isSameLocalDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function yesterdayOf(now: Date): Date {
  const yesterday = new Date(now);

  yesterday.setDate(yesterday.getDate() - 1);

  return yesterday;
}

// Doses scheduled on the given local calendar day, earliest first.
export function dosesForDay(doses: IMedicationCheckin[], day: Date): IMedicationCheckin[] {
  return doses
    .filter((dose) => isSameLocalDay(new Date(dose.scheduledAt), day))
    .sort((a, b) => new Date(a.scheduledAt).getTime() - new Date(b.scheduledAt).getTime());
}

export function countDoses(doses: IMedicationCheckin[]): IDoseCounts {
  const countOf = (status: string) => doses.filter((dose) => dose.status === status).length;

  return {
    total: doses.length,
    taken: countOf('taken'),
    skipped: countOf('skipped'),
    missed: countOf('missed'),
    pending: countOf('pending')
  };
}

export function getTimeOfDay(date: Date): TimeOfDay {
  const hour = date.getHours();

  if (hour < 12) {
    return 'morning';
  }
  if (hour < 18) {
    return 'afternoon';
  }

  return 'evening';
}

// Only sections that contain at least one dose, in morning, afternoon, evening order.
export function groupByTimeOfDay(doses: IMedicationCheckin[]): IDoseSection[] {
  return TIME_OF_DAY_ORDER
    .map((timeOfDay) => ({
      timeOfDay,
      doses: doses.filter((dose) => getTimeOfDay(new Date(dose.scheduledAt)) === timeOfDay)
    }))
    .filter((section) => section.doses.length > 0);
}

// Mark taken and Skip are offered only for a pending dose whose time has arrived.
export function isDue(dose: IMedicationCheckin, now: Date): boolean {
  return dose.status === 'pending' && new Date(dose.scheduledAt).getTime() <= now.getTime();
}
